"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackOnBlur = exports.setSuccessStatus = exports.setErrorStatus = exports.resetStatus = exports.isTruthyOrZero = exports.isSuccess = exports.isStateContext = exports.isError = exports.getValue = exports.getHelperText = exports.getError = exports.formSubmit = exports.SUCCESS = exports.ERROR = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _isObject = _interopRequireDefault(require("lodash/isObject"));

var _isEqual = _interopRequireDefault(require("lodash/isEqual"));

var _formik = require("formik");

/**
 * Get the value of a field.
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 * @param {string} key data key (e.g. scheduleType in values.scheduleType, errors.scheduleType, etc.)
 * @returns {any} current field value
 */
var getValue = function getValue(props) {
  return props.value;
};
/**
 * Get the error state of a field.
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 * @param {string} key data key (e.g. scheduleType in values.scheduleType, errors.scheduleType, etc.)
 * @returns {boolean} current field error state
 */


exports.getValue = getValue;

var getError = function getError(props, key) {
  return Boolean(props.touched[key] && props.errors[key]);
};
/**
 * Get the helper text of a field.
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 * @param {string} key data key (e.g. scheduleType in values.scheduleType, errors.scheduleType, etc.)
 * @returns {string} current field helper text
 */


exports.getError = getError;

var getHelperText = function getHelperText(props, key) {
  return getError(props, key) ? props.errors[key] : undefined;
};
/**
 * Returns bool depending on if the context exists
 *
 * @param {string} key data key (e.g. scheduleType in values.scheduleType, errors.scheduleType, etc.)
 * @returns {function} onBlur handler for the field
 */


exports.getHelperText = getHelperText;

var isStateContext = function isStateContext() {
  return Boolean((0, _formik.useFormikContext)());
};

exports.isStateContext = isStateContext;

var isTruthyOrZero = function isTruthyOrZero(value) {
  return (0, _isEqual["default"])(value, 0) || Boolean(value);
}; // This is being set in the formik state context under status.
// For clarity about who and what is setting the field add `set by eanrup olympic-lib`.


exports.isTruthyOrZero = isTruthyOrZero;
var SUCCESS = 'success - (set by eanrup olympic-lib)';
exports.SUCCESS = SUCCESS;
var ERROR = 'error - (set by eanrup olympic-lib)';
/**
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 */

exports.ERROR = ERROR;

var setSuccessStatus = function setSuccessStatus(props) {
  return props.setStatus(SUCCESS);
};
/**
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 */


exports.setSuccessStatus = setSuccessStatus;

var setErrorStatus = function setErrorStatus(error, props) {
  return props.setStatus(error);
};
/**
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 */


exports.setErrorStatus = setErrorStatus;

var resetStatus = function resetStatus(props) {
  return props.setStatus(null);
};
/**
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 */


exports.resetStatus = resetStatus;

var isSuccess = function isSuccess(props) {
  return (0, _isEqual["default"])(props.status, SUCCESS);
};
/**
 *
 * @param {object} props FormikBag (e.g. { values, errors, touched, ...etc })
 */


exports.isSuccess = isSuccess;

var isError = function isError(props) {
  return Boolean(props.status) && !(0, _isEqual["default"])(props.status, SUCCESS);
};
/**
 * Wraps the submit function in order to set submission status
 * on the formik context
 * @param {function} onSubmitProp submit function
 */


exports.isError = isError;

var formSubmit = function formSubmit(onSubmitProp) {
  return /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(values, options) {
      var res;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              resetStatus(options);
              _context.prev = 1;
              _context.next = 4;
              return onSubmitProp(values, options);

            case 4:
              res = _context.sent;

              if (!(res && res.formError)) {
                _context.next = 8;
                break;
              }

              setErrorStatus(res.formError, options);
              return _context.abrupt("return", res.formError);

            case 8:
              setSuccessStatus(options);
              _context.next = 15;
              break;

            case 11:
              _context.prev = 11;
              _context.t0 = _context["catch"](1);
              setErrorStatus(_context.t0, options);
              throw _context.t0;

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[1, 11]]);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

exports.formSubmit = formSubmit;

var trackOnBlur = function trackOnBlur(ev, onBlur, name) {
  window.analytics && window.analytics.track('blur', {
    name: name
  });
  if ('function' === typeof onBlur) onBlur(ev);
};

exports.trackOnBlur = trackOnBlur;